@if (magicLink() === false) {
  <div class="wrapper">
    <header role="banner">
      <app-simple-header [lang]="lang()" />
    </header>

    <main class="auth-container" role="main">
      <router-outlet />
    </main>

    <footer class="footer" role="contentinfo">
      <app-footer
        [footerClass]="'blue-border'"
        class="footer"
        [lang]="lang()"
      />
    </footer>
  </div>
} @else {
  <div class="spinner">
    <spinner />
  </div>
}
